import { Link } from "react-router-dom";
import GruvyLogo from "../Logos/Gruvy Education Green Logo.png";

function SiteHeader({
  registerHref = "/#register",
  registerLabel = "Register free",
  showRegisterButton = true,
  onRegisterClick,
}) {
  return (
    <header className="site-header">
      <div className="container header-row">
        <Link className="brand" to="https://gruvyeducation.com" target="_blank" rel="noreferrer">
          <img className="brand-logo" src={GruvyLogo} alt="Gruvy Education" />
          <span className="brand-text">Gruvy Education's Monthly AI Lab for School Leaders</span>
        </Link>

        {showRegisterButton ? (
          <div className="header-actions">
            <Link className="btn btn-subtle header-hub-btn" to="/hub">
              Lab Hub
            </Link>

            {onRegisterClick ? (
              <button
                className="btn btn-primary header-register-btn"
                type="button"
                onClick={onRegisterClick}
              >
                {registerLabel}
              </button>
            ) : (
              <a className="btn btn-primary header-register-btn" href={registerHref}>
                {registerLabel}
              </a>
            )}
          </div>
        ) : null}
      </div>
    </header>
  );
}

export default SiteHeader;
